import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { IMG_BASE_URL, StudentProfile } from '../../../AllAPI/StudentAPI'

const ProfileDetails = () => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  const formDataFromStorage = JSON.parse(
    sessionStorage.getItem('studentData') || '{}',
  )
  const RegId = formDataFromStorage.reg_id
  const BoardingYear = formDataFromStorage.year

  // Format date ⇒ dd/mm/yyyy
  const formatDate = (dateString) => {
    if (!dateString) return '-'
    const d = new Date(dateString)
    return d.toLocaleDateString('en-GB') // dd/mm/yyyy
  }

  useEffect(() => {
    fetchProfile()
  }, [])

  const fetchProfile = async () => {
    try {
      const res = await axios.get(`${StudentProfile}/${RegId}/${BoardingYear}`)
      setData(res.data)
    } catch (err) {
      console.log('Error:', err)
    }
    setLoading(false)
  }

  if (loading) return <h4 className="text-center mt-5">Loading...</h4>
  if (!data) return <h4 className="text-center mt-5">No Profile Found</h4>

  const docs = data.documents || {}
  const payment = data.payment || {}
  const room = data.roombooking || {}

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-lg-2"></div>
        <div className="col-12 col-lg-8">
          <div className="header-row">
            <h2 className="page-title">
              Student Profile Details (ವಿದ್ಯಾರ್ಥಿ ಪ್ರೊಫೈಲ್ ವಿವರಗಳು)
            </h2>
          </div>

          {/* ========================= PERSONAL INFO ============================= */}
          <div className="card shadow-sm p-4 mb-4">
            <div className="row align-items-center">
              <h5 className="mb-3 p-0" style={{ color: '#235784' }}>
                Personal Information (ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ) -
              </h5>

              {/* Profile Image */}
              <div className="col-12 col-md-4 text-center border rounded shadow pt-2">
                <img
                  src={`${IMG_BASE_URL}${docs.s_pic}`}
                  alt="Student"
                  className="rounded-circle shadow"
                  style={{
                    width: '160px',
                    height: '160px',
                    objectFit: 'cover',
                    border: '3px solid #ddd',
                  }}
                />
                <h4
                  className="mt-3 px-2 rounded"
                  style={{ backgroundColor: '#fdf07bff' }}
                >{`${data.s_fname} ${data.s_mname} ${data.s_lname}`}</h4>
                {/* <p className="text-muted"> Reg ID: {data.reg_id}</p> */}
              </div>

              {/* Basic Info */}
              <div className="col-12 col-md-8">
                <div className="row">
                  {[
                    ['Date of Birth (ಹುಟ್ಟಿದ ದಿನಾಂಕ)', data.date_of_birth],
                    ['Email (ಇಮೇಲ್)', data.email],
                    ['WhatsApp No (ನಂ)', data.wh_mobile],
                    ['Mobile (ಮೊಬೈಲ್)', data.mobile],
                  ].map(([label, value]) => (
                    <>
                      <div className="col-12 col-md-6 mb-3" key={label}>
                        <span style={{ fontWeight: '500' }}>{label}:</span>
                        <p className="border rounded p-2 bg-light">{value}</p>
                      </div>
                    </>
                  ))}
                </div>
              </div>

              <div className="col-12 pt-2">
                <div className="row">
                  <div className="col-12 col-md-4 mb-3">
                    <span style={{ fontWeight: '500' }}>Religion (ಧರ್ಮ):</span>
                    <p className="border rounded p-2 bg-light">
                      {data.religion.religion_name}
                    </p>
                  </div>
                  <div className="col-12 col-md-4 mb-3">
                    <span style={{ fontWeight: '500' }}>Caste (ಜಾತಿ):</span>
                    <p className="border rounded p-2 bg-light">
                      {data.castname.cast_name}
                    </p>
                  </div>
                  <div className="col-12 col-md-4 mb-3">
                    <span style={{ fontWeight: '500' }}>
                      Blood Group (ರಕ್ತದ ಗುಂಪು):
                    </span>
                    <p className="border rounded p-2 bg-light">
                      {data.blood_grp}
                    </p>
                  </div>
                  <div className="col-12 mb-3">
                    <span style={{ fontWeight: '500' }}>Address (ವಿಳಾಸ):</span>
                    <p className="border rounded p-2 bg-light">
                      {data.address}, {data.village}, Pin: {data.pin}, State:{' '}
                      {data.location.stateenname} District:{' '}
                      {data.location.districtenname} Taluka:{' '}
                      {data.location.talukaenname}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ========================= ACADEMIC INFO ============================= */}
          <div className="card shadow-sm p-4 mb-4">
            <div className="row align-items-center">
              <h5 className="mb-3 p-0" style={{ color: '#235784' }}>
                Academic Information (ಶೈಕ್ಷಣಿಕ ಮಾಹಿತಿ) -
              </h5>
              <div className="row">
                {[
                  [
                    'Name of School / College Last Attended (ಕೊನೆಯದಾಗಿ ವ್ಯಾಸಂಗ ಮಾಡಿದ ಶಾಲೆ / ಕಾಲೇಜಿನ ಹೆಸರು)',
                    data.last_attended_clg_name,
                  ],
                  [
                    'Highest Qualification Obtained (ಅತ್ಯುನ್ನತ ಅರ್ಹತೆ ಪಡೆದಿದ್ದಾರೆ)',
                    data.highest_qualification,
                  ],
                  [
                    'Aggregate Percentage (%) (ಒಟ್ಟು ಶೇಕಡಾವಾರು (%))',
                    data.aggre_percentage,
                  ],
                  [
                    'Month & Year of Passing (ತೇರ್ಗಡೆಯಾದ ತಿಂಗಳು ಮತ್ತು ವರ್ಷ)',
                    data.month_year_of_passing,
                  ],
                  [
                    'Name of Institution Currently Enrolled In (ಪ್ರಸ್ತುತ ದಾಖಲಾಗಿರುವ ಸಂಸ್ಥೆಯ ಹೆಸರು)',
                    data.curr_yr_clg_name,
                  ],
                  [
                    'Course / Program Name (ಕೋರ್ಸ್ / ಕಾರ್ಯಕ್ರಮದ ಹೆಸರು)',
                    data.course_name,
                  ],
                  [
                    'Total Course Duration (ಒಟ್ಟು ಕೋರ್ಸ್ ಅವಧಿ)',
                    data.total_course_duration,
                  ],
                  [
                    'Remaining Duration of Course (ಉಳಿದಿರುವ ಕೋರ್ಸ್ ಅವಧಿ)',
                    data.remaining_course_duration,
                  ],
                ].map(([label, value]) => (
                  <div className="col-12 col-md-6 mb-3" key={label}>
                    <span style={{ fontWeight: '500' }}>{label}:</span>
                    <p className="border rounded p-2 bg-light">{value}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* ========================= FATHER DETAILS ============================= */}
          <div className="card shadow-sm p-4 mb-4">
            <div className="row align-items-center">
              <h5 className="mb-3 p-0" style={{ color: '#235784' }}>
                Father Details (ತಂದೆಯ ವಿವರಗಳು) -
              </h5>
              <div className="row">
                {[
                  [
                    'Full Name (ಪೂರ್ಣ ಹೆಸರು)',
                    `${data.father_fname} ${data.father_mname} ${data.father_lname}`,
                  ],
                  ['Mobile (ಮೊಬೈಲ್)', data.father_mob],
                ].map(([label, value]) => (
                  <div className="col-12 col-md-6 mb-3" key={label}>
                    <span style={{ fontWeight: '500' }}>{label}:</span>
                    <p className="border rounded p-2 bg-light">{value}</p>
                  </div>
                ))}

                <div className="col-12 pt-2">
                  <div className="row">
                    <div className="col-12 col-md-4 mb-3">
                      <span style={{ fontWeight: '500' }}>Age (ವಯಸ್ಸು):</span>
                      <p className="border rounded p-2 bg-light">
                        {data.father_age}
                      </p>
                    </div>
                    <div className="col-12 col-md-4 mb-3">
                      <span style={{ fontWeight: '500' }}>
                        Occupation (ಉದ್ಯೋಗ):
                      </span>
                      <p className="border rounded p-2 bg-light">
                        {data.father_occ}
                      </p>
                    </div>
                    <div className="col-12 col-md-4 mb-3">
                      <span style={{ fontWeight: '500' }}>
                        Family Members (ಕುಟುಂಬ ಸದಸ್ಯರು):
                      </span>
                      <p className="border rounded p-2 bg-light">
                        {data.total_family_mamber}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ========================= MOTHER DETAILS ============================= */}
          <div className="card shadow-sm p-4 mb-4">
            <div className="row align-items-center">
              <h5 className="mb-3 p-0" style={{ color: '#235784' }}>
                Mother Details (ತಾಯಿಯ ವಿವರಗಳು)-
              </h5>
              <div className="row">
                {[
                  [
                    'Full Name (ಪೂರ್ಣ ಹೆಸರು)',
                    `${data.father_fname} ${data.father_mname} ${data.father_lname}`,
                  ],
                  ['Mobile (ಮೊಬೈಲ್)', data.father_mob],
                  ['Age (ವಯಸ್ಸು)', data.father_age],
                  ['Occupation (ಉದ್ಯೋಗ)', data.father_occ],
                ].map(([label, value]) => (
                  <div className="col-12 col-md-6 mb-3" key={label}>
                    <span style={{ fontWeight: '500' }}>{label}:</span>
                    <p className="border rounded p-2 bg-light">{value}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* ========================= MOTHER DETAILS ============================= */}
          <div className="card shadow-sm p-4 mb-4">
            <div className="row align-items-center">
              <h5 className="mb-3 p-0" style={{ color: '#235784' }}>
                Emergency Details (ತುರ್ತು ವಿವರಗಳು)-
              </h5>
              <div className="row">
                {[
                  [
                    'Full Name (ಪೂರ್ಣ ಹೆಸರು)',
                    `${data.emergency_name}`,
                  ],
                  ['Mobile (ಮೊಬೈಲ್)', data.emergency_contact],                 
                ].map(([label, value]) => (
                  <div className="col-12 col-md-6 mb-3" key={label}>
                    <span style={{ fontWeight: '500' }}>{label}:</span>
                    <p className="border rounded p-2 bg-light">{value}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* ========================= PAYMENT DETAILS ============================= */}
          {/* <div className="card shadow-sm p-4 mb-4">
        <h5 className="mb-3 p-0" style={{color:"#235784"}}>Payment Details -</h5>

        <div className="row">
          <div className="col-md-6 mb-3">
            <span style={{fontWeight:"500"}}>Registration Payment:</span>
            <p>Date: {formatDate(payment.register_pay_date)}</p>
            <p>Amount: {payment.register_pay_amount}</p>
          </div>

          <div className="col-md-6 mb-3">
            <span style={{fontWeight:"500"}}>Hostel Payment:</span>
            <p>Date: {formatDate(payment.hostel_pay_date)}</p>
            <p>Amount: {payment.hostel_pay_amount}</p>
          </div>
        </div>
      </div> */}

          {/* ========================= ROOM & BED ALLOCATION ============================= */}
          {/* <div className="card shadow-sm p-4 mb-4">
        <h5 className="mb-3 p-0" style={{color:"#235784"}}>Hostel Room Details -</h5>

        {room ? (
          <div className="row">
            <div className="col-md-4">
              <span style={{fontWeight:"500"}}>Room No:</span>
              <p>{room.room?.room_no}</p>
            </div>

            <div className="col-md-4">
              <span style={{fontWeight:"500"}}>Bed No:</span>
              <p>{room.bed?.bed_no}</p>
            </div>

            <div className="col-md-4">
              <span style={{fontWeight:"500"}}>Allocated On:</span>
              <p>{formatDate(room.createdAt)}</p>
            </div>
          </div>
        ) : (
          <p>No Room Allocated</p>
        )}

      </div> */}

          {/* ========================= DOCUMENTS SECTION ============================= */}
          <div className="card shadow-sm p-4 mb-4">
            <h5 className="mb-3" style={{ color: '#235784' }}>
              Documents (ದಾಖಲೆಗಳು) -
            </h5>

            <div className="row text-center">
              {Object.entries({
                'Aadhar Card | (ಆಧಾರ್ ಕಾರ್ಡ್)': docs.s_aadhar,
                'Caste Income Certificate | (ಜಾತಿ ಪ್ರಮಾಣ ಪತ್ರ)':
                  docs.cast_income_cert,
                'Registration Fee Receipt | (ಶಿಫಾರಸು ಪತ್ರ)':
                  docs.recommendation_letter,
                'Recommendation Letter | (ಶಿಫಾರಸು ಪತ್ರ)':
                  docs.recommendation_letter,
                'College Admission Receipt | (ಕಾಲೇಜು ಪ್ರವೇಶ ರಶೀದಿ)':
                  docs.clg_add_receipt,
              }).map(([label, fileName]) => {
                const [english, kannada] = label.split('|')
                const imgSrc = fileName ? IMG_BASE_URL + fileName : null

                return (
                  <div
                    className="col-12 col-md-6 col-lg-4 mb-3 mt-3 pb-4"
                    style={{ border: '1px solid #b8b8b8ff' }}
                    key={label}
                  >
                    <p className="fw-semibold mb-1">
                      {english} <br />
                      <span style={{ fontSize: '13px' }}>{kannada}</span>
                    </p>

                    {imgSrc ? (
                      <img
                        src={imgSrc}
                        alt={label}
                        className="img-fluid rounded border"
                        style={{
                          width: '100%',
                          objectFit: 'contain',
                          display: 'block',
                        }}
                      />
                    ) : (
                      <p className="text-muted">No File</p>
                    )}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-2"></div>
      </div>
    </div>
  )
}

export default ProfileDetails
